import React, { useEffect, useState } from "react";
import { FiChevronRight } from "react-icons/fi";
import "../../assets/css/HelpCenter.css";
import { helpcenter } from "../../assets/Images/ImagesLink.js";
import { Link } from "react-router-dom";

const HelpCenterCard = () => {
  const [isDark, setIsDark] = useState(() => {
    return JSON.parse(localStorage.getItem("isDark")) || false;
  });

  useEffect(() => {
    const handleStorageChange = () => {
      setIsDark(JSON.parse(localStorage.getItem("isDark")) || false);
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  const cardData = [
    { title: "Getting Started", image: "/images/getting-started.jpg" },
    { title: "Mastering Product", image: "/images/mastering-product.jpg" },
    { title: "Integrations", image: "/images/integrations.jpg" },
    { title: "Community", image: "/images/community.jpg" },
    { title: "Add-ons", image: "/images/add-ons.jpg" },
    { title: "API", image: "/images/api.jpg" },
    { title: "News & Updates", image: "/images/news-updates.jpg" },
    { title: "Tutorials", image: "/images/tutorials.jpg" },
    { title: "Tutorials", image: "/images/tutorials.jpg" },
    { title: "Tutorials", image: "/images/tutorials.jpg" },
    { title: "Tutorials", image: "/images/tutorials.jpg" },
    { title: "Tutorials", image: "/images/tutorials.jpg" },
  ];

  return (
    <div className={`help-center-container ${isDark ? "dark-mode" : ""}`}>
      <div className="grid-container">
        {cardData.map((item, index) => (
          <Link to={"/help/" + item?.slugURLvalue} key={index}>
            <div className="help-card cursor-pointer">
              <figure>
                <img
                  src={helpcenter.helpcenterImage}
                  alt={item.title}
                  className="w-100 h-100 object-fit-cover"
                  loading="lazy"
                />
              </figure>

              {/* Content */}
              <div className="help-card-content">
                <h5 className="help-card-title">
                  {item.title}
                  <FiChevronRight size={18} className="chevron-icon" />
                </h5>
                <p className="help-card-description">
                  First steps to join this program
                </p>
                <p className="help-card-note">You must Login & Register</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default HelpCenterCard;
